export const clearError = () => {
    return {
        type: "CLEAR_ERROR",
        payload: {}
    }
}

export const clearLoaders = () => {
    return {
        type: "CLEAR_LOADERS",
        payload: {}
    }
}

export const logout = () => {
    return {
        type: "USER_LOGOUT",
        payload: {}
    }
}